import { useEffect, useRef, useState } from 'react';

const SCRIPT_ID = 'seon-sdk';
const SCRIPT_SRC = 'https://cdn.seonintelligence.com/js/v6/agent.umd.js';
const MAX_POLL_ATTEMPTS = 300;

export const useSeon = () => {
  const [ready, setReady] = useState(false);
  const pollIdRef = useRef<number | null>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement('script');
      s.id = SCRIPT_ID;
      s.src = SCRIPT_SRC;
      s.defer = true;
      s.onerror = () => {
        console.warn('[SEON] SDK script failed to load');
        if (pollIdRef.current) {
          window.clearInterval(pollIdRef.current);
          pollIdRef.current = null;
        }
      };
      document.body.appendChild(s);
    }

    let attempts = 0;
    const check = () => {
      attempts++;
      if (window.seon) {
        setReady(true);
        if (pollIdRef.current) {
          window.clearInterval(pollIdRef.current);
          pollIdRef.current = null;
        }
      } else if (attempts >= MAX_POLL_ATTEMPTS) {
        console.warn('[SEON] SDK did not load after 30s');
        if (pollIdRef.current) {
          window.clearInterval(pollIdRef.current);
          pollIdRef.current = null;
        }
      }
    };

    check();
    if (!window.seon) {
      pollIdRef.current = window.setInterval(check, 100);
    }

    return () => {
      if (pollIdRef.current) {
        window.clearInterval(pollIdRef.current);
        pollIdRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!ready || initializedRef.current) return;
    initializedRef.current = true;

    try {
      window.seon!.init({
        behavioralDataCollection: {
          targets: 'input[type="text"], input[type="email"], input[type="password"]',
        },
      });
    } catch (e) {
      console.warn('[SEON] init() failed:', e);
    }
  }, [ready]);
};

export const SeonGate = () => {
  useSeon();
  return null;
};
